import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.4978 10c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 10c0 3.9981-3.2518 7.6561-5.3227 9.5804-.9594.8914-2.3952.8914-3.3546 0C8.2517 17.6561 5 13.9981 5 10c0-3.866 3.134-7 7-7s7 3.134 7 7Z"
    />
  </svg>
)
export default SvgMapPin
